/* =====================================================================
   PB GIVE BESKED — "Giv mig besked når den er på lager" (kun på udsolgte varianter).
   Sender til PBCards' egen server via pbcards.dk/apps/pb/notify.
   Spam-beskyttelse (Cloudflare Turnstile) hentes først, når kunden åbner formularen.
   Husker hvilke varer kunden allerede venter på (kun variant-id — ingen e-mail gemmes i browseren).
   ===================================================================== */
(function () {
  'use strict';
  var d = document, w = window, box = d.querySelector('[data-pb-notify]');
  if (!box) return;
  var btn = box.querySelector('[data-pb-notify-open]'), form = box.querySelector('[data-pb-notify-form]');
  var msg = box.querySelector('[data-pb-notify-msg]'), tsBox = box.querySelector('[data-pb-notify-ts]');
  var tsId = null, tsToken = '', KEY = 'pbNotify1';
  /* to Turnstile-widgets (gratisplanen: 10 domæner pr. widget) — vælg nøglen til det domæne kunden står på */
  var host = location.hostname.replace(/^www\./, ''), list2 = (box.getAttribute('data-domains2') || '').split(/[\s,]+/).filter(Boolean);
  var siteKey = (list2.indexOf(host) >= 0 && box.getAttribute('data-sitekey2')) || box.getAttribute('data-sitekey') || '';
  function t(k) { return (w.PB && PB.t && PB.t(k)) || k; }
  function mine() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function remember(v) { try { var a = mine().filter(function (x) { return x !== v; }); a.push(v); localStorage.setItem(KEY, JSON.stringify(a.slice(-60))); } catch (e) {} }
  function variant() { return Number(box.getAttribute('data-variant')); }

  function say(text, ok) { msg.hidden = false; msg.textContent = text; msg.className = 'pb-notify__msg ' + (ok ? 'is-ok' : 'is-bad'); }
  function state() {
    var done = mine().indexOf(variant()) >= 0;
    btn.hidden = done; if (done) { form.hidden = true; say(t('nt_already'), true); } else if (msg.classList.contains('is-ok')) { msg.hidden = true; }
  }

  /* spam-beskyttelse: hentes kun når den skal bruges */
  function turnstile() {
    if (!siteKey || tsId !== null) return;
    tsId = 0;
    w.pbTsReady = function () {
      tsId = w.turnstile.render(tsBox, { sitekey: siteKey, size: 'flexible', appearance: 'interaction-only', callback: function (tok) { tsToken = tok; }, 'expired-callback': function () { tsToken = ''; } });
    };
    var s = d.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=pbTsReady'; s.async = true; d.head.appendChild(s);
  }

  function open() {
    form.hidden = false; btn.setAttribute('aria-expanded', 'true'); btn.hidden = true; msg.hidden = true;
    turnstile();
    var em = form.querySelector('input[type=email]'); if (em && !em.value) setTimeout(function () { em.focus(); }, 30);
  }
  btn.addEventListener('click', open);

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = String(form.email.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { say(t('nt_err_email'), false); return; }
    var sb = form.querySelector('button[type=submit]'); sb.disabled = true; sb.classList.add('is-busy');
    var root = (w.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch('/apps/pb/notify', {
      method: 'POST', credentials: 'same-origin', headers: { 'content-type': 'application/json', accept: 'application/json' },
      body: JSON.stringify({ variant_id: variant(), email: email, locale: d.documentElement.lang || 'da', base: location.origin + root, news: !!form.news.checked, ts: tsToken })
    }).then(function (r) { return r.json().catch(function () { return { ok: false, error: 'server' }; }); }).then(function (j) {
      if (j.ok) {
        remember(variant()); form.hidden = true; say(t('nt_ok').replace('[e]', email), true);
      } else {
        var k = { email: 'nt_err_email', rate: 'nt_err_rate', max: 'nt_err_max', in_stock: 'nt_err_stock' }[j.error] || 'nt_err';
        say(t(k), false);
        if (w.turnstile && tsId) { try { w.turnstile.reset(tsId); tsToken = ''; } catch (x) {} }
      }
    }).catch(function () { say(t('nt_err'), false); }).then(function () { sb.disabled = false; sb.classList.remove('is-busy'); });
  });

  /* følg variantskift på produktsiden */
  if (w.PB && PB.on) PB.on('product:variant', upd);
  function upd(v) {
    if (!v || !v.id) return;
    box.setAttribute('data-variant', v.id);
    box.hidden = !!v.available;
    form.hidden = true; btn.hidden = false; btn.setAttribute('aria-expanded', 'false'); msg.hidden = true; msg.className = 'pb-notify__msg';
    state();
  }

  state();
  if (location.hash === '#giv-besked' && !box.hidden) { open(); box.scrollIntoView({ block: 'center' }); }
})();
